import { render, staticRenderFns } from "./TeacherCamera.vue?vue&type=template&id=31e84b46&scoped=true"
import script from "./TeacherCamera.vue?vue&type=script&lang=js"
export * from "./TeacherCamera.vue?vue&type=script&lang=js"
import style0 from "./TeacherCamera.vue?vue&type=style&index=0&id=31e84b46&prod&lang=scss&scoped=true"
import style1 from "./TeacherCamera.vue?vue&type=style&index=1&id=31e84b46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e84b46",
  null
  
)

export default component.exports